import {useMutation} from '@tanstack/react-query';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {useLogout} from '@common/auth/requests/logout';
import {toast} from '@common/ui/toast/toast';
import {useAuth} from '@common/auth/use-auth';
import {apiClient} from '@common/http/query-client';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';

interface Response extends BackendResponse {}

// ▼ فلگ سراسری: تا وقتی false باشد حذف اکانت غیر فعال است.
export const DELETE_ACCOUNT_ENABLED = false;

export function useDeleteAccount() {
  const {user} = useAuth();
  const logout = useLogout();

  return useMutation({
    mutationFn: () => {
      if (!DELETE_ACCOUNT_ENABLED) {
        // جلوی حذف را می‌گیریم و پیام مناسب می‌دهیم
        return Promise.reject(new Error('DELETE_DISABLED'));
      }
      return deleteAccount(user!.id);
    },
    onSuccess: () => {
      toast('Account deleted');
      logout.mutate();
    },
    onError: err => {
      if ((err as Error)?.message === 'DELETE_DISABLED') {
        toast('Account deletion is temporarily disabled.');
      } else {
        showHttpErrorToast(err);
      }
    },
  });
}

function deleteAccount(userId: number): Promise<Response> {
  return apiClient
    .delete(`users/${userId}`, {params: {deleteCurrentUser: true}})
    .then(r => r.data);
}
